import { InjectionToken, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, distinctUntilChanged, filter, shareReplay } from 'rxjs';

import { BetslipType } from '../../core/betslip-type';
import { betslipCurrentTypeSelector } from '../../modules/types/base/selectors';

export const BETSLIP_TYPE_PROVIDER = new InjectionToken<Observable<BetslipType>>('BETSLIP_TYPE_PROVIDER', {
    factory() {
        const store = inject(Store);

        const betslipType$ = store.select(betslipCurrentTypeSelector).pipe(
            filter<BetslipType | null, BetslipType>((type): type is BetslipType => type !== null),
            distinctUntilChanged(),
            shareReplay(1),
        );

        return betslipType$;
    },
    providedIn: 'root',
});
